import { handleCommonErrors } from 'utils/api'
import {
  InvalidUserUnauthorized,
  InvalidUserWrongAccountUsed,
} from '../useAPIKinerja'

import type {
  ResetSKPPhase,
  PraktikKinerjaFormName,
} from 'types/kinerja-penilik-pegawai'

export const basePath = '/guru/pps/v1/penilik'
export const queryKeyBaseName = 'penilik-pegawai'

export const apiPaths = {
  basePath,
  profile: `${basePath}/profile`,
  summary: (periodeId: string) => `${basePath}/${periodeId}/summary`,
  status: (periodeId: string) => `${basePath}/${periodeId}/status`,
  getPeriod: `${basePath}/periode`,

  // Perencanaan
  perencanaan: `${basePath}/perencanaan`,
  perencanaanByPeriod: (periodeId: string) =>
    `${apiPaths.perencanaan}/${periodeId}`,
  pengembanganKompetensi: `${basePath}/perencanaan/pengembangan-kompetensi`,
  summaryPerencanaan: (periodeId: string) =>
    `${apiPaths.perencanaanByPeriod(periodeId)}/summary`,
  ajukanPerencanaan: (periodeId: string) =>
    `${apiPaths.perencanaan}/${periodeId}/ajukan`,
  mulaiPelaksanaan: `${basePath}/perencanaan/mulai-pelaksanaan`,
  resetSkp: (periodeId: string, phase: ResetSKPPhase) =>
    `${basePath}/${periodeId}/skp/reset/${phase}`,
  syncToEkin: `${basePath}/perencanaan/sync-to-ekin`,
  praktikKinerja: `${basePath}/perencanaan/praktik-kinerja`,

  // Pelaksanaan
  pelaksanaan: `${basePath}/pelaksanaan`,
  praktikKinerjaForm: (skpId: string, formName: PraktikKinerjaFormName) =>
    `${apiPaths.pelaksanaan}/praktik-kinerja/${skpId}/form-values/${formName}`,
  praktikKinerjaFormSubmit: (skpId: string) =>
    `${apiPaths.pelaksanaan}/praktik-kinerja/${skpId}`,
  pelaksanaanTugas: (skpId: string) =>
    `${apiPaths.pelaksanaan}/pelaksanaan-tugas/${skpId}`,
  notification: `${basePath}/notification`,
} as const

export const queryKeys = {
  API_GET_PROFILE: `${queryKeyBaseName}-profile`,
  API_GET_SUMMARY: `${queryKeyBaseName}-summary`,
  API_GET_STATUS: `${queryKeyBaseName}-status`,
  API_GET_PERIODE_DETAIL: `${queryKeyBaseName}-period-detail`,

  // Perencanaan
  API_GET_PERENCANAAN: `${queryKeyBaseName}-perencanaan`,
  API_GET_PERENCANAAN_SUMMARY: `${queryKeyBaseName}-perencanaan-summary`,
  API_GET_PRAKTIK_KINERJA_OPTIONS: `${queryKeyBaseName}-perencanaan-praktik-kinerja`,
  API_GET_SATUAN_PENDIDIKAN_OPTIONS: `${queryKeyBaseName}-perencanaan-satuan-pendidikan`,
  API_GET_PENGEMBANGAN_KOMPETENSI_INDIKATOR: `${queryKeyBaseName}-perencanaan-indikator`,
  API_GET_PENGEMBANGAN_KOMPETENSI_KATEGORI: `${queryKeyBaseName}-perencanaan-kategori`,
  API_GET_PENGEMBANGAN_KOMPETENSI_KEGIATAN: `${queryKeyBaseName}-perencanaan-kegiatan`,

  // Pelaksanaan
  API_GET_PELAKSANAAN_PERILAKU_KERJA: `${queryKeyBaseName}-pelaksanaan-perilaku-kerja`,
  API_GET_PELAKSANAAN_PENGEMBANGAN_KOMPETENSI: `${queryKeyBaseName}-pengembangan-kompetensi`,
  API_GET_PRAKTIK_KINERJA_PERENCANAAN_SUMMARY: `${queryKeyBaseName}-praktik-kinerja-perencanaan-summary`,
  API_GET_PELAKSANAAN_FORM_PRAKTIK_KINERJA: `${queryKeyBaseName}-form-praktik-kinerja`,
  API_GET_PRAKTIK_KINERJA_PELAKSANAAN_SUMMARY: `${queryKeyBaseName}-praktik-kinerja-summary`,
  API_GET_PRAKTIK_KINERJA_PELAKSANAAN: `${queryKeyBaseName}-praktik-kinerja`,
  API_GET_PRAKTIK_KINERJA_FORM_VALUES: `${queryKeyBaseName}-praktik-kinerja-form-values`,
  API_GET_PELAKSANAAN_TUGAS: `${queryKeyBaseName}-pelaksanaan-tugas`,
  API_GET_PRAKTIK_KINERJA_PELAKSANAAN_SURVEY_PENDAMPINGAN: `${queryKeyBaseName}-praktik-kinerja-survey-pendampingan`,
  API_GET_NOTIFICATION_LIST: `${queryKeyBaseName}-notification-list`,
}

export function handleError(status, path, error) {
  if (status === 401) {
    throw new InvalidUserUnauthorized(path, error)
  } else if (status === 403) {
    throw new InvalidUserWrongAccountUsed(path, error)
  } else {
    handleCommonErrors(status, path, error)
  }
}

export function validateStatus(status: number) {
  return status < 400
}
